import { Play } from "lucide-react";
import { useWatchModal } from "../context/WatchModalContext";

const SIZES = {
  sm: "px-4 py-2 text-xs gap-1.5",
  md: "px-7 py-3 text-sm gap-2",
  lg: "px-10 py-4 text-base gap-2.5",
};

export const WatchNowButton = ({ item, size = "md", className = "", testId = "watch-now-btn" }) => {
  const { openWatch } = useWatchModal();
  return (
    <button
      type="button"
      onClick={() => openWatch(item)}
      data-testid={testId}
      aria-haspopup="dialog"
      className={`btn-gold inline-flex items-center justify-center rounded-full font-semibold uppercase tracking-[0.14em] ${SIZES[size]} ${className}`}
    >
      <Play className="h-4 w-4 fill-current" />
      Watch Now
    </button>
  );
};
